import { useEffect, useState } from 'react';

import { useDispatch } from 'react-redux';

import { getPageTypesConfig } from 'components/Pages/Admin/Page/Landing/pageTypesConfig';
import { setLandingDataThunk } from 'store/itinerariesItem/thunks';

const preparePages = (pages) => {
  return pages.map((page) => {
    const config = getPageTypesConfig(page.type);
    const placeholders = config.useMockData(page);
    const updatedPage = page.blocks?.length === 0 ? { ...page, ...placeholders } : page;

    return updatedPage;
  });
};

function usePagesInitializer(guestPortal) {
  const [initialized, setInitialized] = useState(false);
  const dispatch = useDispatch();
  const guestPortalPages = preparePages(guestPortal.landing?.pages || []);

  useEffect(() => {
    dispatch(setLandingDataThunk({ pages: guestPortalPages }, { isLocalUpdate: true }));
    setInitialized(true);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { initialized };
}

export default usePagesInitializer;
